module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Tomb-Raider.e7eb15f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Tomb-Raider.jpg
// module id = +sh1
// module chunks = 0